import { LinkIcon, PlusIcon, CalendarDaysIcon } from "@heroicons/react/20/solid";

const DashboardEmptyState = ({ onShareBookingLink, onCreateAppointment }) => {
  return (
    <div className="bg-white rounded-card shadow-hairline border border-ink-100 p-8 lg:p-12 min-h-[24rem] flex flex-col items-center justify-center text-center">
      <div aria-hidden="true" className="size-12 rounded-full bg-cream-100 flex items-center justify-center mb-5">
        <CalendarDaysIcon className="size-6 text-ink-400" />
      </div>
      <p className="smallcaps text-ink-400 mb-2">Today</p>
      <h2 className="font-display text-3xl text-ink-900 tracking-display">
        No appointments today
      </h2>
      <p className="text-sm text-ink-500 mt-2 max-w-sm">
        Your schedule is open. Share your booking link to fill the day, or add an appointment manually.
      </p>
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 mt-6 w-full sm:w-auto">
        <button
          type="button"
          onClick={onShareBookingLink}
          className="inline-flex items-center justify-center gap-x-1.5 rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-white hover:bg-accent-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-500"
        >
          <LinkIcon className="size-4 -ml-0.5" />
          Share Booking Link
        </button>
        <button
          type="button"
          onClick={onCreateAppointment}
          className="inline-flex items-center justify-center gap-x-1.5 rounded-md bg-white px-4 py-2 text-sm font-semibold text-ink-900 ring-1 ring-inset ring-ink-200 hover:bg-cream-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink-200"
        >
          <PlusIcon className="size-4 -ml-0.5" />
          New Appointment
        </button>
      </div>
    </div>
  );
};

export default DashboardEmptyState;
